import { render, staticRenderFns } from "./PageSlides.vue?vue&type=template&id=e8421406&scoped=true"
import script from "./PageSlides.vue?vue&type=script&lang=js"
export * from "./PageSlides.vue?vue&type=script&lang=js"
import style0 from "./PageSlides.vue?vue&type=style&index=0&id=e8421406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8421406",
  null
  
)

export default component.exports